"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const shallow_1 = require("zustand/shallow");
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const useCycle_1 = require("hooks/api/useCycle");
const useAddNewReviewees_1 = require("hooks/useAddNewReviewees/useAddNewReviewees");
const AnalyticUtils_1 = require("utils/AnalyticUtils");
const FormalReview_1 = require("utils/FormalReview");
const HeaderPage_1 = __importDefault(require("components/admin/HeaderPage"));
const ProgressTracker_1 = __importDefault(require("components/design-system/ProgressTracker/ProgressTracker"));
const Footer_1 = __importDefault(require("components/shared/Footer"));
const HelperUtils_1 = require("src/utils/HelperUtils");
const AddReviewee_1 = __importDefault(require("./add-new-reviewees/AddReviewee"));
const SetupConfiguration_1 = __importDefault(require("./add-new-reviewees/SetupConfiguration"));
const AddNewReviewees = () => {
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { user } = (0, UserContext_1.useUser)();
    const { id } = (0, react_router_1.useParams)();
    const history = (0, react_router_1.useHistory)();
    const { payloadBody, cycleData, setCycleData, getFormatedPayloadBody, checkIsEmailValid, handleChangeState, isToggleNotificationStakeholdersOn } = (0, useAddNewReviewees_1.useAddNewReviewees)((state) => ({
        payloadBody: state.payloadBody,
        cycleData: state.cycleData,
        setCycleData: state.setCycleData,
        getFormatedPayloadBody: state.getFormatedPayloadBody,
        checkIsEmailValid: state.checkIsEmailValid,
        handleChangeState: state.handleChangeState,
        isToggleNotificationStakeholdersOn: state.isToggleNotificationStakeholdersOn
    }), shallow_1.shallow);
    // ** Hook to post new reviewee data to backend
    const { mutate: postNewReviewee, isLoading } = (0, useCycle_1.usePostNewReviewee)(parseInt(id));
    const { includes, excludes, selectAll, emailStakeholders } = (0, react_1.useMemo)(() => payloadBody, [payloadBody]);
    const isMemberSelected = (0, react_1.useMemo)(() => (includes === null || includes === void 0 ? void 0 : includes.length) > 0 || (excludes === null || excludes === void 0 ? void 0 : excludes.length) > 0 || selectAll, [includes, excludes, selectAll]);
    const [activeMenu, setActiveMenu] = (0, react_1.useState)('addNewReviewees');
    const options = (0, react_1.useMemo)(() => [
        {
            id: 'addNewReviewees',
            name: 'Add New Reviewees',
            active: activeMenu === 'addNewReviewees',
            iconText: '1',
            isChecked: isMemberSelected,
            onClick: () => setActiveMenu('addNewReviewees')
        },
        {
            id: 'setUpConfiguration',
            name: 'Set Up Configuration',
            active: activeMenu === 'setUpConfiguration',
            iconText: '2',
            disabled: !isMemberSelected,
            onClick: () => setActiveMenu('setUpConfiguration')
        }
    ], [activeMenu, isMemberSelected]);
    const isLastMenuActive = (0, react_1.useMemo)(() => options[options.length - 1].id === activeMenu, [activeMenu, options]);
    const isFirstMenuActive = (0, react_1.useMemo)(() => options[0].id === activeMenu, [activeMenu, options]);
    const isEmailValid = (0, react_1.useMemo)(() => checkIsEmailValid(), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [checkIsEmailValid, emailStakeholders, isToggleNotificationStakeholdersOn]);
    const handleSubmit = () => {
        const body = getFormatedPayloadBody();
        if (isEmailValid) {
            postNewReviewee(body, {
                onSuccess: () => {
                    // ** Redirect to appraisals/cycles page
                    history.push('/appraisals/cycles');
                    // ** Track event to amplitude
                    (0, AnalyticUtils_1.trackEvent)({
                        event: 'add new reviewees',
                        eventProperties: {
                            cycleId: id,
                            adminId: user.id,
                            listPlacementId: {
                                includes: body.includes,
                                excludes: body.excludes,
                                selectAll: body.selectAll
                            },
                            reviewDeadline: body.assignmentEndsAt,
                            emailConfigForReviewee: body.notifyNewReviewee,
                            listEmailForStakeholders: body.emailStakeholders
                        },
                        env: 'performance'
                    });
                    // ** Show toast success message
                    addToast({
                        title: (0, HelperUtils_1.getObjectiveLocale)('Success'),
                        msg: (0, HelperUtils_1.getObjectiveLocale)('New Reviewees Successfully Added'),
                        type: 'success'
                    });
                }
            });
        }
    };
    const getCurrentActiveMenuIndex = () => {
        const currentActiveMenuIndex = options.findIndex((option) => option.id === activeMenu);
        return currentActiveMenuIndex;
    };
    const onClickNext = () => {
        if (isLastMenuActive) {
            handleSubmit();
            return;
        }
        const currentActiveMenuIndex = getCurrentActiveMenuIndex();
        setActiveMenu(options[currentActiveMenuIndex + 1].id);
    };
    const onClickBack = () => {
        const currentActiveMenuIndex = getCurrentActiveMenuIndex();
        setActiveMenu(options[currentActiveMenuIndex - 1].id);
    };
    (0, useCycle_1.useGetCycleDetail)(parseInt(id), {
        onSuccess: (data) => {
            setCycleData(data === null || data === void 0 ? void 0 : data.data);
            // ** Set default assignmentEndsAt
            handleChangeState((draft) => {
                var _a;
                draft.payloadBody.assignmentEndsAt = (0, FormalReview_1.getDefaultReviewDeadline)((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.reviewProcessEndsAt);
            });
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderPage_1.default, { titlePage: cycleData === null || cycleData === void 0 ? void 0 : cycleData.name, backToUrl: "/appraisals/cycles", isHeaderComposer: true }),
        react_1.default.createElement("div", { className: "flex !p-[0px] h-full min-h-min" },
            react_1.default.createElement("div", { className: "bg-n-200 border-solid border-r border-0 border-n-400 !pt-[24px] w-[256px] h-full fixed z-10" },
                react_1.default.createElement(ProgressTracker_1.default, { options: options })),
            react_1.default.createElement("div", { className: "px-[40px] pt-[24px] w-[calc(100%-256px)] ml-[256px] bg-n-000 h-min min-h-[100%]" },
                activeMenu === 'addNewReviewees' && react_1.default.createElement(AddReviewee_1.default, null),
                activeMenu === 'setUpConfiguration' && react_1.default.createElement(SetupConfiguration_1.default, null))),
        react_1.default.createElement(Footer_1.default, { buttonPrimaryName: isLastMenuActive ? 'Submit' : 'Next', linkButtonName: "Back", secondaryButton: true, handleClick: onClickNext, handleRoute: onClickBack, linkButtonDisabled: isFirstMenuActive, isButtonPrimaryLoading: isLoading, buttonPrimaryDisabled: isLastMenuActive ? !isEmailValid : !isMemberSelected })));
};
const AddNewRevieweesWrapper = () => {
    return (react_1.default.createElement(useAddNewReviewees_1.AddNewReviweesProvider, null,
        react_1.default.createElement(AddNewReviewees, null)));
};
exports.default = AddNewRevieweesWrapper;
